export const examData = [
  {
    category: "HEMATOLOGY",
    cisExamName: "COMPLETE BLOOD COUNT (CBC)",
    cisExamCode: "HEMA0041",
    items: [
      { code: "HCT", name: "Hematocrit", unit: "", reference: "", key: "hematocrit" },
      { code: "HGB", name: "Hemoglobin", unit: "g/dL", reference: "", key: "hemoglobin_g" },
      { code: "HGB", name: "Hemoglobin", unit: "mmol/L", reference: "", key: "hemoglobin_mmol" },
      { code: "MHC", name: "MHC", unit: "pg/cell", reference: "", key: "mhc_pg" },
      { code: "MHC", name: "MHC", unit: "fmol/cell", reference: "", key: "mhc_fmol" },
      { code: "MCHC", name: "MCHC", unit: "fmol/cell", reference: "", key: "mchc_ghb" },
      { code: "MCHC", name: "MCHC", unit: "mmol/Hb/L", reference: "", key: "mchc_mmol" },
      { code: "MCV", name: "MCV", unit: "um^3", reference: "", key: "mcv_um" },
      { code: "MCV", name: "MCV", unit: "fL", reference: "", key: "mcv_fl" },
      { code: "WBC", name: "WBC Count", unit: "x10^3 cells/mm^3", reference: "", key: "wbc_1000" },
      { code: "WBC", name: "WBC Count", unit: "x10^9/L", reference: "", key: "wbc_10" },
      { code: "MYEL", name: "Myelocyte", unit: "", reference: "", key: "myelocyte" },
      { code: "NEUTB", name: "Neutrophil Bands", unit: "", reference: "", key: "neutrophils_bnd" },
      { code: "NEUTS", name: "Neutrophil Segmenters", unit: "", reference: "", key: "neutrophils_seg" },
      { code: "LYMPH", name: "Lymphocyte", unit: "", reference: "", key: "lymphocytes" },
      { code: "MONO", name: "Monocyte", unit: "", reference: "", key: "monocytes" },
      { code: "EOSI", name: "Eosinophil", unit: "", reference: "", key: "eosinophils" },
      { code: "BASO", name: "Basophil", unit: "", reference: "", key: "basophils" },
      { code: "PLT", name: "Platelet", unit: "", reference: "", key: "platelet" },
    ]
  },
  {
    category: "CLINICAL MICROSCOPY",
    cisExamName: "URINALYSIS",
    cisExamCode: "CLMC0031",
    items: [
      { code: "USGRAV", name: "Gravity", unit: "", reference: "", key: "gravity" },
      { code: "UTRANS", name: "Appearance", unit: "", reference: "", key: "appearance" },
      { code: "UCOLOR", name: "Color", unit: "", reference: "", key: "color" },
      { code: "GLU", name: "Glucose", unit: "", reference: "", key: "glucose" },
      { code: "UPROT", name: "Proteins", unit: "", reference: "", key: "proteins" },
      { code: "UKET", name: "Ketones", unit: "", reference: "", key: "ketones" },
      { code: "UPH", name: "pH", unit: "", reference: "", key: "ph" },
      { code: "RB", name: "RBC", unit: "/hpf", reference: "", key: "rb_cells" },
      { code: "UWBC", name: "WBC", unit: "/hpf", reference: "", key: "wb_cells" },
      { code: "UBACT", name: "Bacteria", unit: "/hpf", reference: "", key: "bacteria" },
      { code: "XTALS", name: "Crystals", unit: "/hpf", reference: "", key: "crystals" },
      { code: "pBladderCell", name: "Bladder Cells", unit: "/hpf", reference: "", key: "bladder_cell" },
      { code: "pSquamousCell", name: "Squamous Cells", unit: "/hpf", reference: "", key: "squamous_cell" },
      { code: "pTubularCell", name: "Tubular Cell", unit: "/hpf", reference: "", key: "tubular_cell" },
      { code: "pBroadCasts", name: "Broad Casts", unit: "/hpf", reference: "", key: "broad_casts" },
      { code: "UECELL", name: "Epithelial Cast", unit: "/hpf", reference: "", key: "epithelial_cast" },
      { code: "pGranularCast", name: "Granular Cast", unit: "/hpf", reference: "", key: "granular_cast" },
      { code: "pHyalineCast", name: "Hyaline Cast", unit: "/hpf", reference: "", key: "hyaline_cast" },
      { code: "pRbcCast", name: "RBC Cast", unit: "/hpf", reference: "", key: "rbc_cast" },
      { code: "pWaxyCast", name: "Waxy Cast", unit: "/hpf", reference: "", key: "waxy_cast" },
      { code: "pWcCast", name: "Wc Cast", unit: "/hpf", reference: "", key: "wc_cast" },
      { code: "pAlbumin", name: "Albumin", unit: "/mg/dl", reference: "", key: "albumin" },
      { code: "pPusCells", name: "Pus Cells", unit: "", reference: "", key: "pus_cells" },
    ]
  },
  {
    category: "RADIOLOGY",
    cisExamName: "CHEST X-RAY PA VIEW",
    cisExamCode: "RADI0001",
    items: [
      { code: "pFindings", 
        name: "Findings", 
        unit: "", 
        reference: "", 
        key: "findings",
        type: "select",
        options: [
          {
            label: "NORMAL",
            key: "1",
            library_status: "1"
          },
          {
            label: "BRONCHIOLITIS",
            key: "10",
            library_status: "1"
          },
          {
            label: "CHRONIC OBSTRUCTIVE PULMONARY DISEASE",
            key: "11",
            library_status: "1"
          },
          {
            label: "PULMONARY MASS",
            key: "12",
            library_status: "1"
          },
          {
            label: "PNEUMONIA",
            key: "2",
            library_status: "1"
          },
          {
            label: "PTB/KOCHS",
            key: "3",
            library_status: "1"
          },
          {
            label: "PLEURAL EFFUSION",
            key: "4",
            library_status: "1"
          },
          {
            label: "PNEUMOTHORAX",
            key: "5",
            library_status: "1"
          },
          {
            label: "EMPHYSEMA",
            key: "6",
            library_status: "1"
          },
          {
            label: "CHRONIC BRONCHITIS",
            key: "7",
            library_status: "1"
          },
          {
            label: "BRONCHIECTASIS",
            key: "8",
            library_status: "1"
          },
          {
            label: "ACUTE BRONCHITIS",
            key: "9",
            library_status: "1"
          },
          {
            label: "OTHERS",
            key: "99",
            library_status: "1"
          },
        ]
      },
      { code: "pRemarksFindings", 
        name: "Remarks Findings", 
        unit: "", 
        reference: "",
        key: "remarks_findings",
      },
      { code: "pObservation", 
        name: "Observation", 
        unit: "", 
        reference: "", 
        key: "observation",
        type: "select",
        options: [
          {
            label: "INFILTRATES",
            key: "1",
            library_status: "1"
          },
          {
            label: "THICKENING",
            key: "10",
            library_status: "1"
          },
          {
            label: "HYPERAERATION/ EMPHYSEMATOUS",
            key: "11",
            library_status: "1"
          },
          {
            label: "MASS",
            key: "12",
            library_status: "1"
          },
          {
            label: "CALCIFICATION",
            key: "2",
            library_status: "1"
          },
          {
            label: "CONSOLIDATION",
            key: "3",
            library_status: "1"
          },
          {
            label: "CAVITY",
            key: "4",
            library_status: "1"
          },
          {
            label: "DENSITIES",
            key: "5",
            library_status: "1"
          },
          {
            label: "PLEURAL EFFUSION",
            key: "6",
            library_status: "1"
          },
          {
            label: "PNEUMOTHORAX",
            key: "7",
            library_status: "1"
          },
          {
            label: "BLEB",
            key: "8",
            library_status: "1"
          },
          {
            label: "CARDIOMEGALY",
            key: "9",
            library_status: "1"
          },
          {
            label: "OTHERS",
            key: "99",
            library_status: "1"
          },
        ]
      },
      { code: "pRemarksObservation", 
        name: "RemarksObservation", 
        unit: "", 
        reference: "", 
        key: "remarks_observation",
      },
    ]
  },
  {
    category: "LABORATORY",
    cisExamName: "(SPUTUM AFB)",
    cisExamCode: "LABO0001",
    items: [
      { code: "pDataCollection", 
        name: "Data Collection", 
        unit: "", 
        reference: "", 
        key: "data_collection",
        type: "select",
        options: [
          {
            label: "First Collection",
            key: "1",
            library_status: "1"
          },
          {
            label: "Second Collection",
            key: "2",
            library_status: "1"
          },
          {
            label: "Third Collection",
            key: "3",
            library_status: "1"
          },
          {
            label: "Not Applicable",
            key: "X",
            library_status: "1"
          },
        ]
      },
      { code: "pFindings", 
        name: "Findings", 
        unit: "", 
        reference: "", 
        key: "findings",
        type: "select",
        options: [
          {
            label: "Essentially Normal",
            key: "1",
            library_status: "1"
          },
          {
            label: "With Findings",
            key: "2",
            library_status: "1"
          },
        ]
      },
      { code: "pRemarks", 
        name: "Remarks", 
        unit: "", 
        reference: "", 
        key: "remarks",
        showIf: { key: "findings", value: "With Findings" }
      },
      { code: "pNoPlusses", 
        name: "No Plusses", 
        unit: "", 
        reference: "", 
        key: "no_plusses",
        maxLength: 5,
      },
    ]
  },
  {
    category: "CLINICAL CHEMISTRY",
    cisExamName: "LIPID PROFILE",
    cisExamCode: "CLCH0145",
    items: [
      { code: "pLdl", 
        name: "LDL", 
        unit: "mg/dL", 
        reference: "", 
        key: "ldl" 
      },
      { code: "pHdl", 
        name: "HDL", 
        unit: "mg/dL", 
        reference: "", 
        key: "hdl" 
      },
      { code: "pTotal", 
        name: "Total Cholesterol", 
        unit: "mg/dL", 
        reference: "", 
        key: "total" 
      },
      { code: "pCholesterol", 
        name: "Cholesterol", 
        unit: "mg/dL", 
        reference: "", 
        key: "cholesterol" 
      },
      { code: "pTriglycerides", 
        name: "Triglycerides", 
        unit: "mg/dL", 
        reference: "", 
        key: "triglycerides" 
      },
    ]
  },
  {
    category: "ULTRASOUND",
    cisExamName: "ECG (12 LEADS)",
    cisExamCode: "ECG",
    items: [
      { code: "pFindings", 
        name: "Findings", 
        unit: "", 
        reference: "", 
        key: "findings",
        type: "select",
        options: [
          {
            label: "Essentially Normal",
            key: "1",
            library_status: "1"
          },
          {
            label: "With Findings",
            key: "2",
            library_status: "1"
          },
        ]
      },
      { code: "pRemarks", 
        name: "Remarks", 
        unit: "", 
        reference: "", 
        key: "remarks",
        showIf: { key: "findings", value: "With Findings" } 
      },
    ]
  },
  {
    category: "ULTRASOUND",
    cisExamName: "FASTING BLOOD SUGAR (FBS)",
    cisExamCode: "FBS",
    items: [
      { code: "pGlucoseMg", 
        name: "Glucose", 
        unit: "mg/dL", 
        reference: "", 
        key: "glucose_mg" 
      },
      { code: "pGlucoseMmol", 
        name: "Glucose", 
        unit: "mmol/L", 
        reference: "", 
        key: "glucose_mmol" 
      },
    ]
  },
  {
    category: "LABORATORY",
    cisExamName: "RANDOM BLOOD SUGAR (RBS)",
    cisExamCode: "FBS",
    items: [
      { code: "pGlucoseMg", 
        name: "Glucose", 
        unit: "mg/dL", 
        reference: "", 
        key: "glucose_mg",
      },
      { code: "pGlucoseMmol", 
        name: "Glucose", 
        unit: "mmol/L", 
        reference: "", 
        key: "glucose_mmol",
      },
    ]
  },
  {
    category: "LABORATORY",
    cisExamName: "FECALYSIS",
    cisExamCode: "FECALYSIS",
    items: [
      { code: "pColor", 
        name: "Color", 
        unit: "", 
        reference: "", 
        key: "color",
        type: "select",
        options: [
          {
            label: "Brown",
            key: "1",
            library_status: "1"
          },
          {
            label: "Black",
            key: "2",
            library_status: "1"
          },
          {
            label: "Red",
            key: "3",
            library_status: "1"
          },
          {
            label: "White/Grey",
            key: "4",
            library_status: "1"
          },
          {
            label: "Yellow",
            key: "5",
            library_status: "1"
          },
          {
            label: "Green",
            key: "6",
            library_status: "1"
          },
        ]
      },
      { code: "pConsistency", 
        name: "Consistency", 
        unit: "", 
        reference: "", 
        key: "consistency",
      },
      { code: "pRbc", 
        name: "RBC", 
        unit: "", 
        reference: "", 
        key: "rbc",
      },
      { code: "pWbc", 
        name: "WBC", 
        unit: "", 
        reference: "", 
        key: "wbc",
      },
      { code: "pOva", 
        name: "Ova", 
        unit: "", 
        reference: "", 
        key: "ova",
      },
      { code: "pParasite", 
        name: "Parasite", 
        unit: "", 
        reference: "", 
        key: "parasite",
      },
      { code: "pBlood", 
        name: "Blood", 
        unit: "", 
        reference: "", 
        key: "blood",
        type: "select",
        options: [
          {
            label: "Present",
            key: "P",
            library_status: "1"
          },
          {
            label: "Absent",
            key: "A",
            library_status: "1"
          },
        ]
      },
      { code: "pPusCells", 
        name: "Pus Cells", 
        unit: "", 
        reference: "", 
        key: "pus_cells",
      },
    ]
  },
  {
    category: "LABORATORY",
    cisExamName: "PAP SMEAR (CYTOPATH STUDY) CERVICOVAGINAL - PCP",
    cisExamCode: "PCP",
    items: [
      { code: "pFindings", 
        name: "Findings", 
        unit: "", 
        reference: "", 
        key: "findings",
        maxLength: 500,
      },
      { code: "pImpression", 
        name: "Impression", 
        unit: "", 
        reference: "", 
        key: "impression",
      },
    ]
  },
  {
    category: "LABORATORY",
    cisExamName: "GLUCOSE (AFTER 75G GLUCOSE LOAD) - 75GOGTT",
    cisExamCode: "OGTT",
    items: [
      { code: "pExamFastingMg", 
        name: "Fasting Examination", 
        unit: "mg/dL", 
        reference: "", 
        key: "exam_fasting_mg",
      },
      { code: "pExamFastingMmol", 
        name: "Fasting Examination", 
        unit: "mmol/L", 
        reference: "", 
        key: "exam_fasting_mmol",
      },
      { code: "pExamOgttOneHrMg", 
        name: "1 Hour Examination", 
        unit: "mg/dL", 
        reference: "", 
        key: "exam_ogtt_one_hr_mg",
      },
      { code: "pExamOgttOneHrMmol", 
        name: "1 Hour Examination", 
        unit: "mmol/L", 
        reference: "", 
        key: "exam_ogtt_one_hr_mmol",
      },
      { code: "pExamOgttTwoHrMg", 
        name: "2 Hours Examination", 
        unit: "mg/dL", 
        reference: "", 
        key: "exam_ogtt_two_hr_mg",
      },
      { code: "pExamOgttTwoHrMmol", 
        name: "2 Hours Examination", 
        unit: "mmol/L", 
        reference: "", 
        key: "exam_ogtt_two_hr_mmol",
      },
    ]
  },
  {
    category: "LABORATORY",
    cisExamName: "FECAL OCCULT BLOOD (RAPID)",
    cisExamCode: "FOBT",
    items: [
      { code: "pFindings", 
        name: "Findings", 
        unit: "", 
        reference: "", 
        key: "findings",
        type: "select",
        options: [
          {
            label: "Positive",
            key: "P",
            library_status: "1"
          },
          {
            label: "Negative",
            key: "N",
            library_status: "1"
          },
        ]
      },
    ]
  },
  {
    category: "LABORATORY",
    cisExamName: "CREATININE, SERUM",
    cisExamCode: "CREATININE, SERUM",
    items: [
      { code: "pFindings", 
        name: "Findings", 
        unit: "", 
        reference: "", 
        key: "findings",
        maxLength: 100,
      },
    ]
  },
  {
    category: "LABORATORY",
    cisExamName: "HBA1C",
    cisExamCode: "HBA1C",
    items: [
      { code: "pFindings", 
        name: "Findings", 
        unit: "", 
        reference: "", 
        key: "findings",
        maxLength: 1000,
      },
    ]
  },
];